module.exports = __webpack_public_path__ + "a96bded6e7d910796d072df82ef3640a.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/colossal_clashes-872.jpg
// module id = 232
// module chunks = 0